import React, { FC, useMemo, useState } from 'react';
import { Button, message } from 'antd';
import { BUYER_ONLY_NO_STORE_ASSOCIATE } from '../roles/roles';
import { isUserAllowedToAccess, PERMISSION_NAMES } from '../../utils/AuthUtils';
import {
	checkHasApprovalHierarchy,
	compareStrings,
	nullSafeGet,
} from '../../utils/DataAccessUtils';
import { dateFormatter, getNumberSuffix } from '../../utils/DataFormatterUtils';
import { isInApprovalHierarchy } from '../../utils/ApprovalHierarchyUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';

const UndeferComponent: FC<any> = ({
	currentUser,
	workOrder,
	unsnoozeWorkOrder,
	companyConfig,
	refreshWorkOrder,
}): React.ReactElement => {
	const [buttonLoading, setButtonLoading] = useState(false);

	const undeferType = compareStrings(nullSafeGet('status', workOrder), 'Snoozed')
		? 'Unsnooze'
		: 'Undefer';
	const snoozeUntilDate = workOrder.snoozeUntil
		? dateFormatter(workOrder.snoozeUntil, 'MMMM D').concat(
				getNumberSuffix(workOrder.snoozeUntil),
				', ',
				dateFormatter(workOrder.snoozeUntil, 'YYYY')
		  )
		: null;
	const question = `This work order is ${
		nullSafeGet('status', workOrder) === 'Snoozed' ? 'snoozed' : 'deferred'
	}${snoozeUntilDate ? ' until '.concat(snoozeUntilDate) : ''}.`;
	const userType = nullSafeGet('userType', currentUser);

	const hasDeferPermission = useMemo(
		() =>
			checkHasApprovalHierarchy(workOrder)
				? isInApprovalHierarchy(currentUser, nullSafeGet('approvalHierarchy', workOrder))
				: isUserAllowedToAccess(userType)(
						PERMISSION_NAMES.CAN_DEFER_WORK_ORDERS,
						companyConfig,
						currentUser.roles
				  ),
		[]
	);

	return (
		<div>
			<h5>{question}</h5>
			{hasDeferPermission ? (
				<div style={{ marginTop: 16, marginBottom: 20 }}>
					<Button
						type="primary"
						key="approve"
						loading={buttonLoading}
						onClick={() => {
							setButtonLoading(true);
							unsnoozeWorkOrder({ id: workOrder.id })
								.then(() => refreshWorkOrder())
								.catch((errorMessage) =>
									message.error(
										errorMessage || `Could not ${undeferType.toLowerCase()} work order.`
									)
								)
								.finally(() => setButtonLoading(false));
						}}
					>
						{undeferType} work order
					</Button>
				</div>
			) : null}
		</div>
	);
};

export default UndeferComponent;
